const ProductStatus = require("../models/productStatus");
const CustomerTypes = require('./customerTypes');
const Product = require("../product");
const {productLib} = require('@nuskin/product-lib');

/**
 * Get product by ID
 * @todo map promotions coming from promotions API
 * @param {string} id
 * @param {string} market
 * @param {string} locale
 * @param {obj} config
 */
async function getProduct(id, market, locale, config) {

  const productData = {
    products: [],
    count: 0
  };

  const okta = typeof sessionStorage !== 'undefined' ? parseOktaObject(sessionStorage.oktaTokens) : null;

  try {
    const data = await productLib.getProduct({
      fromId: id,
      market: market,
      language: locale,
      env: config.graphqlUrl.includes('test') ? 'test' : config.graphqlUrl.includes('dev') ? 'dev' : 'prod',
      okta
    });
    if (data && data.data) {
      //use to get default variant based on requested sku
      config.sku = id;
      const product = mapProduct(data.data, market, locale, config);
      productData.products.push(new Product(product));
      productData.count = productData.products.length;
    }

  } catch (e) {
    console.log(`Unable to fetch product detail for SKU ${id}`);
  }

  return {
    data: {
      "status": 200,
      "messages": [],
      "data": productData
    }
  };
}

/**
 * Get products by IDs
 * @todo map promotions coming from promotions API
 * @param {string[]} ids
 * @param {string} market
 * @param {string} locale
 * @param {obj} config
 */
async function getProducts(ids, market, locale, config) {

  const productsData = {
    products: [],
    count: 0
  };

  if (!Array.isArray(ids)) {
    ids = [ids]
  }

  const okta = typeof sessionStorage !== 'undefined' ? parseOktaObject(sessionStorage.oktaTokens) : null;

  try {
    const data = await productLib.getProductsById(
      ids, market, locale, 
      null, 1, okta, 
      config.graphqlUrl.includes('test') ? 'test' : config.graphqlUrl.includes('dev') ? 'dev' : 'prod'
    );
    if (data && data.products) {
      const mappedProducts = mapSkusToProducts(ids,data.products);
      //use to get default variant based on requested sku
      mappedProducts.forEach(({sku , product})=>{
        config.sku = sku;
        const newProduct = mapProduct(product, market, locale, config);
        productsData.products.push(new Product(newProduct));
      });
      productsData.count = productsData.products.length;
    }
  } catch (e) {
    console.log(`Unable to fetch products details for SKUs ${ids}`);
  }

  return {
    data: {
      "status": 200,
      "messages": [],
      "data": productsData
    }
  };
}


/**
 * Map skus array to products array
 * @param {string[]} skus
 * @param {any} products
 */

function mapSkusToProducts(skus, products){
  const productsData = [];
  if (products && products.length) {
    skus.forEach((sku)=>{
      const matchedProducts = products.filter((product)=>{
        let matched = false;
        if(product.id) {matched = product.id === sku;}
        if(product.variants && product.variants.length){
          product.variants.forEach((variant)=>{
            matched |=  variant.sku === sku;
          });
        }
        return matched;
      });
      if(matchedProducts.length > 0){
        productsData.push({ sku: sku , product: matchedProducts[0]});
      }
    })
  }
  return productsData;

}

function addPrice(productData, priceTypeKey, subKey, priceValue) {
  if (!['Points', 'cv', 'price', 'pv'].includes(priceTypeKey)) {
    // if the priceTypeKey is not one of these, then we don't want it to show.
    return;
  }
  if (priceTypeKey === 'pv') {
    priceTypeKey = 'psv';
  }
  if (priceTypeKey === 'cv') {
    priceTypeKey = 'csv';
  }

  if (productData[priceTypeKey] === undefined) {
    if (priceTypeKey === 'Points') {
      if (!productData.price) {
        productData.price = {};
      }
      productData.price.PTS = priceValue;
      return;
    } else {
      productData[priceTypeKey] = {};
    }
  }
  productData[priceTypeKey][subKey] = priceValue;
}

function convertPricingJson(pricing, productData) {
  if (pricing) {
    Object.keys(pricing).forEach((channelKey) => {
      Object.keys(pricing[channelKey]).forEach((contextKey) => {
        Object.keys(pricing[channelKey][contextKey] || {}).forEach((priceTypeKey) => {
          const priceValue = pricing[channelKey][contextKey][priceTypeKey];
          switch (channelKey) {
            case 'wholesale':
              switch (contextKey) {
                case 'webOrder':
                  addPrice(productData, priceTypeKey, 'WWHL', priceValue);
                  break;
                case 'webAdr':
                case 'WADW':
                case 'ADR5':
                  addPrice(productData, priceTypeKey, 'WADW', priceValue);
                  break;
                case 'order':
                case 'WHL':
                  addPrice(productData, priceTypeKey, 'WHL', priceValue);
                  break;
                case 'adr':
                  addPrice(productData, priceTypeKey, 'ADW', priceValue);
                  break;
                case 'ADR10':
                case 'WADWD':
                  addPrice(productData, priceTypeKey, 'WADWD', priceValue);
                  break;
                default:
                  addPrice(
                    productData,
                    priceTypeKey,
                    `${contextKey}-WWHL`,
                    priceValue
                  );
                  break;
              }
              break;
            case 'retail':
              switch (contextKey) {
                case 'webOrder':
                  addPrice(productData, priceTypeKey, 'WRTL', priceValue);
                  break;
                case 'webAdr':
                  addPrice(productData, priceTypeKey, 'WADR', priceValue);
                  break;
                case 'order':
                case 'RTL':
                  addPrice(productData, priceTypeKey, 'RTL', priceValue);
                  break;
                case 'adr':
                  addPrice(productData, priceTypeKey, 'ADR', priceValue);
                  break;
                default:
                  addPrice(
                    productData,
                    priceTypeKey,
                    `${contextKey}-WRTL`,
                    priceValue
                  );
                  break;
              }
              break;
          }
        });
      });
    });
  }
}

function mapPricingJson(productDetail, kitOrVariant, isContentStack) {
  if (isContentStack) {
    const pricingMap = JSON.parse(kitOrVariant.pricingJson)
    const convertedMap = {}
    convertPricingJson(pricingMap, convertedMap)
    Object.assign(productDetail.priceMap, convertedMap.price)
    Object.assign(productDetail.cvMap, convertedMap.csv)
    Object.assign(productDetail.pvMap, convertedMap.psv)
  }
}

/**
 *
 * Map product data to be product card consumable structure *
 * @param {object} product
 * @param {string} market
 * @param {string} locale
 * @param {object} config
 * @returns {object} Product
 */
// eslint-disable-next-line no-unused-vars
function mapProduct(product, market, locale, config) {
  const kitBundleProducts = product.bundle;
  
  //serves as parent
  const defaultVariant = !kitBundleProducts ? product.variants.find(v => v.sku === config.sku) : null
  const kitOrVariant = !kitBundleProducts ? defaultVariant : kitBundleProducts
  const productOrVariant = !kitBundleProducts ? defaultVariant : product
  const productImages = mapProductImages(productOrVariant)
  const pricing = kitOrVariant.price
  const points = kitOrVariant.points
  const isBackOrdered = kitOrVariant.status.inventory === 'backordered'
  const promoData = mapPromos(kitOrVariant)

  const productDetail = {
    "sku": !kitBundleProducts ? defaultVariant.sku : product.id,
    "globalProductID": productOrVariant.globalId && productOrVariant.globalId !== productOrVariant.sku ? productOrVariant.globalId : productOrVariant.id,
    "title": productOrVariant.title,
    "country": market,
    "language": locale,
    "shortDescr": productOrVariant.description,
    "longDescr": (productOrVariant.productDetails || {}).description,
    "fullImage": productImages.fullImage,
    "imageAltText": productImages.imageAltText,
    "thumbnail": productImages.thumbnail,
    "ingredients": productOrVariant.ingredients,
    "benefits": productOrVariant.benefits,
    "usage": productOrVariant.usage,
    "resources": productOrVariant.resources,
    "availableQuantity": isBackOrdered ? kitOrVariant.backorderQuantity : kitOrVariant.atpQuantity,
    "maxQuantity": kitOrVariant.maxQuantity,
    "points": "",
    "cv": points && points.wholesale ? points.wholesale.cv : 0,
    "pv": points && points.wholesale ? points.wholesale.pv : 0,
    "priceType": "WRTL",
    "price": pricing.retail,
    "priceMap": {
      ...promoData.priceMap,
      "ADR": pricing.retailSubscription,
      "ADW": pricing.wholesaleSubscription,
      "WRTL": pricing.retail,
      "WADW-WRTL": pricing.retailSubscription,
      "WADR": pricing.retailSubscription,
      "RTL": pricing.retail,
      "WWHL": pricing.wholesale,
      "WADW": pricing.wholesaleSubscription,
      "WHL": pricing.wholesale
    },
    "cvMap": {
      ...promoData.cvMap,
      "WWHL": points &&  points.wholesale ? points.wholesale.cv : 0,
      "WADW": points && points.subscription ? points.subscription.cv : 0,
      "WHL": points && points.wholesale ? points.wholesale.cv : 0
    },
    "pvMap": {
      ...promoData.pvMap,
      "WWHL": points && points.wholesale ? points.wholesale.pv : 0,
      "WADW": points && points.subscription ? points.subscription.pv : 0,
      "WHL": points && points.wholesale ? points.wholesale.pv : 0
    },
    "orderTypes": mapOrderTypes(kitOrVariant.availableChannels, kitOrVariant.purchaseTypes),
    "custTypes": mapCustomerTypes(kitOrVariant.customerTypes),
    "backOrderDate": kitOrVariant.backorderedAvailableDate,
    "size": productOrVariant.size,
    "status": mapProductStatus(kitOrVariant.status.status),
    "variantType": "Other",
    "variantDropdownLabel": product.variantSelectLabel || '',
    "variantDropdownPlaceholder": "Select Type",
    "variantsLabel": productOrVariant.variantLabel || '',
    "groupOffer": false,
    "personalOffer": false,
    "savedEventName": '',
    "salesLabel": promoData.message || '',
    "eventName": promoData.offerId || '',
    "sizeWeight": '',
    "nettoWeight": "",
    "searchScore": 0,
    "isExclusive": kitOrVariant.isExclusive || false,
    "equinoxProductId": product.id,
    "inventory": isBackOrdered ? 'BACKORDER' : 'IN STOCK',
    "properties": {
      isBackOrdered: isBackOrdered,
      inventoryStatus: isBackOrdered ? 'BACKORDER' : 'IN STOCK',
      productStatus: mapProductStatus(kitOrVariant.status.status)
    }
  }

  const isContentStack = product.productDataSource.source === 'contentstack'
  mapPricingJson(productDetail, kitOrVariant, isContentStack)

  //map only if it is normal product
  if (product.variants && !kitBundleProducts) {
    productDetail.variants = mapVariants(product, isContentStack);
  }

  if (kitBundleProducts) {

    //assemble childSku
    //1st elememt should be parent product
    //graphql returns product type lowercase, this will cause add to cart error if not uppercase
    productDetail.childSkus = [
      {
        availableChannels: Array.isArray(kitBundleProducts.availableChannels) ? kitBundleProducts.availableChannels.join(',') : kitBundleProducts.availableChannels,
        productId: product.id,
        skuId: product.id,
        type: kitBundleProducts.type.toUpperCase()
      },
      ...mapChildSKU(kitBundleProducts)
    ];
  }

  return productDetail;
}

/**
 * Map product variants
 * @param {*} product
 * @param {boolean} isContentStack
 * @returns {Array<object>}  productVariants
 */
function mapVariants(product, isContentStack) {

  //return if it  has no variant
  if (!product.variants || (product.variants && product.variants.length === 1)) {
    return [];
  }

  const variants = [];

  product.variants.forEach(variant => {
    const sku = variant.sku || variant.id;

    const productImages = mapProductImages(variant);
    const pricing = variant.price
    const points = variant.points
    const isBackOrdered = variant.status.inventory === 'backordered'
    const promoData = mapPromos(variant)

    variants[sku] = {
      "sku": sku,
      "globalProductID": product.id || variant.globalId,
      "title": variant.title,
      "shortDescr": variant.description,
      "longDescr": variant.productDetails.description,
      "fullImage": productImages.fullImage,
      "imageAltText": productImages.imageAltText,
      "thumbnail": productImages.thumbnail,
      "ingredients": variant.ingredients,
      "benefits": variant.benefits,
      "usage": variant.usage,
      "resources": variant.resoruces,
      "availableQuantity": variant.availableQuantity,
      "maxQuantity": variant.maxQuantity,
      "points": "",
      "cv": points && points.wholesale ? points.wholesale.cv : 0,
      "pv": points && points.wholesale ? points.wholesale.pv : 0,
      "priceType": "WRTL",
      "price": pricing.retail,
      "priceMap": {
        ...promoData.priceMap,
        "ADR": pricing.retailSubscription,
        "ADW": pricing.wholesaleSubscription,
        "WRTL": pricing.retail,
        "WADW-WRTL": pricing.retailSubscription,
        "WADR": pricing.retailSubscription,
        "RTL": pricing.retail,
        "WWHL": pricing.wholesale,
        "WADW": pricing.wholesaleSubscription,
        "WHL": pricing.wholesale
      },
      "cvMap": {
        ...promoData.cvMap,
        "WWHL": points && points.wholesale ? points.wholesale.cv : 0,
        "WADW": points && points.subscription ? points.subscription.cv : 0,
        "WHL": points && points.wholesale ? points.wholesale.cv : 0
      },
      "pvMap": {
        ...promoData.pvMap,
        "WWHL": points && points.wholesale ? points.wholesale.pv : 0,
        "WADW": points && points.subscription ? points.subscription.pv : 0,
        "WHL": points && points.wholesale ? points.wholesale.pv : 0
      },
      "orderTypes": mapOrderTypes(variant.availableChannels, variant.purchaseTypes),
      "custTypes": mapCustomerTypes(variant.customerTypes),
      "backOrderDate": variant.status.backorderedAvailableDate,
      "size": variant.size,
      "status": mapProductStatus(variant.status.status),
      "variantType": "Other",
      "variantDropdownLabel": variant.variantLabel || '',
      "variantDropdownPlaceholder": "Select Type",
      "variantsLabel": variant.variantLabel || '',
      "variants": [],
      "groupOffer": false,
      "personalOffer": false,
      "savedEventName": '',
      "salesLabel": variant.salesLabel || variant.salesText,
      "eventName": variant.salesLabel || variant.salesText,
      "sizeWeight": '',
      "nettoWeight": "",
      "searchScore": 0,
      "isExclusive": variant.isExclusive || false,
      "equinoxProductId": product.id,
      "inventory": isBackOrdered ? 'BACKORDER' : 'IN STOCK',
      "properties": {
        isBackOrdered: isBackOrdered,
        inventoryStatus: isBackOrdered ? 'BACKORDER' : 'IN STOCK',
        productStatus: mapProductStatus(variant.status.status)
      }
    }
    mapPricingJson(variants[sku], variant, isContentStack)
  });

  return variants;
}

/**
 * map product kit bundle child SKUs
 * @param {*} kitBundleProducts
 * @returns {array} kitBundleProducts
 */
function mapChildSKU(kitBundleProducts) {
  if (!kitBundleProducts || !kitBundleProducts.kitProducts) /* istanbul ignore next */ {
    return [];
  }
  const personalOffer = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('personalOffer') ? JSON.parse(sessionStorage.getItem('personalOffer')) : false
  return kitBundleProducts.kitProducts.map((kitProduct) => {
    const { product } = kitProduct;
    if (product.variants.length > 1 && typeof personalOffer === 'object') /* istanbul ignore next */ {
      return product.variants.map((variant) => {
        return {
          productId: product.id,
          skuId: variant.sku,
          type: kitProduct.isMandatory ? 'MANDATORY' : 'OPTIONAL',
          skuQuantity: kitProduct.quantity,
          // eslint-disable-next-line max-len
          availableChannels: Array.isArray(kitBundleProducts.availableChannels) ? kitBundleProducts.availableChannels.join(',') : kitBundleProducts.availableChannels,
          inventory: {
            atpQty: variant.atpQuantity,
            backOrdered: variant.status.inventory === 'backordered',
            backOrderedQty: variant.backorderQuantity
          }
        }
      })
    } else {
      const defaultVariant = product.variants[0];
      return {
        productId: product.id,
        skuId: defaultVariant.sku,
        type: kitProduct.isMandatory ? 'MANDATORY' : 'OPTIONAL',
        skuQuantity: kitProduct.quantity,
        availableChannels: Array.isArray(kitBundleProducts.availableChannels) ? kitBundleProducts.availableChannels.join(',') : kitBundleProducts.availableChannels,
        inventory: {
          atpQty: defaultVariant.atpQuantity,
          backOrdered: defaultVariant.status.inventory === 'backordered',
          backOrderedQty: defaultVariant.backorderQuantity
        }
      }
    }
  }).flat();
}


/**
 * map EQ customer types to supported product card customer types
 * @param {Array<string>} eqCustomerTypes
 * @returns{string} customer types
 */
function mapCustomerTypes(eqCustomerTypes) {
  if (!eqCustomerTypes) {
    return "";
  }

  const custTypes = eqCustomerTypes;

  let newCustType = [];
  if (custTypes.includes(CustomerTypes.BrandAffiliate)) {
    newCustType.push(CustomerTypes.properties.BRAND_AFFILIATE.code);
  }

  if (custTypes.includes(CustomerTypes.Retail)) {
    newCustType.push(CustomerTypes.properties.RETAIL.code);
  }

  if (custTypes.includes(CustomerTypes.Preferred) || custTypes.includes(CustomerTypes.PreferredCustomer)) {
    newCustType.push(CustomerTypes.properties.PREFERRED.code);
  }

  return newCustType.toString()
}

/**
 * map product Images
 *  {
 *    url: "string",
 *    alt: "string",
 *    thumbnail:  "string"
 *  }
 * @param {*} product
 * @returns {object}  productImages
 */
function mapProductImages(product) {

  const productImages = {
    fullImage: "",
    imageAltText: "",
    thumbnail: ""
  };

  if (product.productImages && product.productImages.length) {
    productImages.fullImage = product.productImages[0].url || '';
    productImages.imageAltText = product.productImages[0].alt || '';
    productImages.thumbnail = product.productImages[0].thumbnail || '';
  } else if (product.variants && product.variants.length) {
    if (product.variants[0].productImages && product.variants[0].productImages.length) {
      productImages.fullImage = product.variants[0].productImages[0].url || '';
      productImages.imageAltText = product.variants[0].productImages[0].alt || '';
      productImages.thumbnail = product.variants[0].productImages[0].thumbnail || '';
    }
  }

  return productImages;
}

/**
 * Map Order Types
 * @param {Array<string>} availableChannels
 * @param {object} purchaseTypes
 * @returns {object} orderTypes
 */
function mapOrderTypes(availableChannels, purchaseTypes) {

  let orderTypes = {
    "adr": false,
    "order": false,
    "zpfc": false,
    "zadp": false,
    "ars": false,
    "kiosk": false,
    "mobile": false,
    "preferred customer": false,
    "retail": false,
    "web": false,
    "web display": false
  };

  if (availableChannels) {
    let availableChannelsArr = Array.isArray(availableChannels) ? availableChannels : availableChannels.split(',');

    availableChannelsArr.forEach(channel => {
      if (channel == 'arsPhone')
        orderTypes.ars = true
      if (channel == 'web') {
        orderTypes.order = true
        orderTypes.web = true
      }
      if (channel == 'kiosk')
        orderTypes.kiosk = true
      if (channel == 'mobile')
        orderTypes.mobile = true
      if (channel == 'subscription')
        orderTypes.adr = true
    });
  }

  if (purchaseTypes && purchaseTypes.buyOnce) {
    orderTypes.web = true
    orderTypes.order = true
  }
  if (purchaseTypes && !purchaseTypes.buyOnce) {
    orderTypes.web = false
    orderTypes.order = false
  }
  if (purchaseTypes && purchaseTypes.subscription) {
    orderTypes.adr = true
  }
  if (purchaseTypes && !purchaseTypes.subscription) {
    orderTypes.adr = false
  }

  return orderTypes;
}

/**
 * Map product status from Equinox format to Product card format
 * @param {string} status
 * @returns {string} status
 */
/* istanbul ignore next */
function mapProductStatus(status) {
  const { equinoxStatus } = ProductStatus;
  let newStatus = '';
  switch (status.toLowerCase()) {
    case equinoxStatus.SELLABLE:
      newStatus = ProductStatus.ReleasedForSale;
      break;
    case equinoxStatus.PREVIEW_PRODUCT:
      newStatus = ProductStatus.NotReleasedForSale;
      break;
    case equinoxStatus.DISCONTINUED:
      newStatus = ProductStatus.Discontinued;
      break;
    case equinoxStatus.STOPPED:
      newStatus = ProductStatus.Discontinued;
      break;
    case equinoxStatus.REPLACEMENT:
      newStatus = ProductStatus.NotReleasedForSale;
      break;
    default:
      newStatus = ProductStatus.NotReleasedForSale;
      break;
  }
  return newStatus;
}

/* istanbul ignore next */
function mapPromos(product) {
  if ((product.price.retailSales !== null && product.price.retailSales >= 0) ||
      (product.price.wholesaleSales !== null && product.price.wholesaleSales >= 0)) {
    if (product.pricingJson) {
      const parsedPricing = JSON.parse(product.pricingJson)
      let promotion = parsedPricing.promotion
      if (promotion && promotion.length) {
        if (promotion.length > 1) {
          promotion = promotion.filter(p=>p.message !== 'Bundle discount')
        }
        const offerId = promotion[0].offerId || 'EQPROMO'
        return {
          priceMap: {[`${offerId}-WRTL`]: product.price.retailSales, [`${offerId}-WWHL`]: product.price.wholesaleSales},
          cvMap: {[`${offerId}-WWHL`]: product.points.wholesale.cv},
          pvMap: {[`${offerId}-WWHL`]: product.points.wholesale.pv},
          message: product.salesLabel || promotion[0].message,
          offerId
        }
      }
      if (parsedPricing.retail) {
        const filter = ['adr', 'order', 'webAdr', 'webOrder']
        const priceMap = {}, cvMap = {}, pvMap = {}
        const retailActiveEvents =
          Object.fromEntries(Object.entries(parsedPricing.retail).filter(([k]) => !filter.includes(k)));
        const wholesaleActiveEvents =
          Object.fromEntries(Object.entries(parsedPricing.wholesale).filter(([k]) => !filter.includes(k)));
        let offerId = null
        for (const key in retailActiveEvents) {
          if (Object.hasOwnProperty.call(retailActiveEvents, key)) {
            priceMap[key+'-WRTL'] = retailActiveEvents[key].price;
            offerId = offerId || key;
          }
        }
        for (const key in wholesaleActiveEvents) {
          if (Object.hasOwnProperty.call(wholesaleActiveEvents, key)) {
            priceMap[key+'-WWHL'] = wholesaleActiveEvents[key].price;
            cvMap[key+'-WWHL'] = wholesaleActiveEvents[key].cv;
            pvMap[key+'-WWHL'] = wholesaleActiveEvents[key].pv;
            offerId = offerId || key;
          }
        }
        return { priceMap, cvMap, pvMap, message: product.salesLabel, offerId }
      }

    }
    return { message: product.salesLabel, offerId: null, priceMap: {}, cvMap: {}, pvMap: {} }
  }
  return {message: product.salesLabel, offerId: null}
}

/* istanbul ignore next */
function parseOktaObject(okta) {
  if (!okta || typeof okta !== 'string') {
    return null;
  }
  const data = JSON.parse(okta);
  if (data.accessToken) {
    if (typeof data.accessToken === 'string') {
      return data.accessToken;
    } else {
      return data.accessToken.accessToken;
    }
  }
}


module.exports = {getProduct , getProducts};